var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: "",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5625 0H5.5625V5H0.5625V0Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5625 7.5H5.5625V12.5H0.5625V7.5Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 15H0.5625V20H5.5625V15Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 0H13.0625V5H8.0625V0Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 7.5H8.0625V12.5H13.0625V7.5Z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 15H13.0625V20H8.0625V15Z",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 0H15.5625V5H20.5625V0Z",
    fill: ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 7.5H20.5625V12.5H15.5625V7.5Z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 15H15.5625V20H20.5625V15Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.cc070dd93839149b9b7ac7928d50716e.svg";
export { ForwardRef as ReactComponent };